import axios from "axios";
import qs from "qs";

const state = {
    product:{}
};

const actions = {
    async loadProduct(context,product_id){
        return axios.get("/api/product", {
            params: {
                id: product_id
            },
            paramsSerializer(params) {
                var result = qs.stringify(params, {
                    arrayFormat: "brackets"
                });
                return result
            }
        }).then(function (response) {
            context.commit("setProduct",response.data)
        })
    },

}

const mutations = {
    setProduct(state,data){
        state.product = data;
    },
}

const getters = {
    product(state){
        return state.product;
    },
};
  
export default {
    state,
    actions,
    mutations,
    getters
};